
import { Button, Table, TableColumn } from 'element-ui';

export default {
  layout: 'account',
  name: 'MyAccount',
  data() {
    return {
      userSession: this.$auth.user.Customer,
      // promoCodeData: [],
    };
  },
  mounted() {
    this.initUser();
  },

  activated() {
    this.initUser();
  },
  updated() {
    if (process.client) {
      document.body.classList.add('account-index-page');
    }
  },
  unmounted() {
    if (process.client) {
      document.body.classList.remove('account-index-page');
    }
  },
  methods: {
    initUser() {
      this.$auth.fetchUser().then((res) => {
        this.userSession = res.data.AuthData.Customer;
      });
    },
    setToken() {


    //  this.$auth.strategy.token.set('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJJZCI6NDM5NzIsIkVtYWlsIjoiY2xpZW50LXRlc3RAeW9wbWFpbC5jb20iLCJGaXJzdG5hbWUiOiJUZXN0dHQiLCJMYXN0bmFtZSI6IlRlc3R0dHQiLCJCaXJ0aGRheSI6IjIwMDAtMDEtMDEiLCJJZENhcnQiOjI0NDkzLCJJZEZhdm9yaXRlIjoxMzUzLCJMYW5ndWFnZUlzb0NvZGUiOiJGUiIsIkN1cnJlbmN5SXNvQ29kZSI6IkVVUiIsIkd1ZXN0IjpmYWxzZSwiaWF0IjoxNzYxOTc0NDAwLCJleHAiOjE3NjIwNjA4MDB9.VE3gRAzsIH38FvEP2fBquz7UdCfhG11Rd5p-xBOfFqo')
    },
  },
  components: {
    Button,
    Table,
    TableColumn,
  },
};
